<template>
<div style="background-color:white;" class="container">


  <!-- {{this.$route.path}}
  {{this.checkpath}} -->
<!-- position:fixed; -->
  <nav class="navbar" role="navigation" aria-label="main navigation" style=" z-index:998; ">
        <div class="navbar-brand">
          <!-- <template v-if="this.checkpath!=='13'||this.checkpath!=='16'"> -->
          <router-link v-if="(this.checkpath=='10')||(this.checkpath=='12')||(this.checkpath=='11')||(this.checkpath=='13')||(this.checkpath=='1')" tag="a" class="navbar-item" to="/servicios">
            <button :onclick="updatepath()" class="button is-link is-outlined">
            Ver todos los tours Exodus</button>
          </router-link>
          <!-- </template> -->
          <br>
          <br>
          <router-link v-if="(this.checkpath=='17')||(this.checkpath=='20')" tag="a" class="navbar-item" to="/servicios/en-usa">
            <button class="button is-link is-outlined">
            See all Exodus Tours</button>
          </router-link>

          <!-- <button @click="cerrarModalBusqueda" class="button is-info">Cerrar</button> -->

          <a @click="menuMobile" role="button" :class="(showMenuMobile)?'navbar-burger burger is-active':'navbar-burger burger'" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample" style=" z-index:999; ">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>

        </div>

        <div id="navbarBasicExample" @click="menuMobile" :class="(showMenuMobile)?'navbar-menu is-active':'navbar-menu'">
          <div class="navbar-start">

            <!-- <router-link tag="a" class="navbar-item" to="/servicios">
              Servicios
            </router-link> -->

            <!-- <a class="navbar-item">
              Test
            </a> -->

            <router-link v-if="(this.checkpath=='10')||(this.checkpath=='12')||(this.checkpath=='11')||(this.checkpath=='13')||(this.checkpath=='1')" tag="a" class="navbar-item" :to="'/contacto'">
              Contacto
            </router-link>

            <router-link v-if="(this.checkpath=='17')||(this.checkpath=='20')" tag="a" class="navbar-item" :to="'/contacto'">
              Contact
            </router-link>
            <!-- <a @click="changeCompon('app-contacto')">Contacto</a> -->
            

            <!-- <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                Services
              </a>

              <div class="navbar-dropdown">
                <a class="navbar-item">
                  About
                </a>
                <a class="navbar-item">
                  Jobs
                </a>
                <a class="navbar-item">
                  Contact
                </a>
                <hr class="navbar-divider">
                <a class="navbar-item">
                  Report an issue
                </a>
              </div>
            </div> -->
          </div>

          <div class="navbar-end">
            <div class="navbar-item">
              <div class="buttons">
                <!-- <router-link tag="a" class="navbar-item" to="/services">
                  English
                </router-link> -->
                <a target="_blank" class="button is-primary">
                  <strong>Registrarse</strong>
                </a>
                <a href="https://exodustickets.sistemy.mx" target="_blank" class="button is-light">
                  Ingresar
                </a>
              </div>
            </div>

            
          </div>
        </div>

        
        
      </nav>



  <!-- {{total}} -->
  <div class="columns">
    
    <!-- <div class="column is-10"> -->
    <div class="column">
      <router-view></router-view>
      <component :is="menuComponente" v-if="$route.path=='/'" ></component>
      <!-- <component :is="menuComponente" ></component> -->
      <!-- <component :is="'contacto'" ></component> -->
    </div>
    <!-- style="overflow-y: scroll; overflow-x: scroll; height: 90vh; margin:0px; display:flex; flex-direction: column;" -->
    <!-- <div class="column is-2 " style="background-color: #f4f4f4; overflow-y: scroll; overflow-x: scroll; height: 90vh; margin:0px; display:flex; flex-direction: column;" >
      <br><br>

      <aside class="menu" >
        <p class="menu-label">
          &nbsp;&nbsp;&nbsp; Sistemy
        </p>
        <ul class="menu-list">
          <li>
            <ul>
               <li><router-link tag="a" to="/cloud"> <font-awesome-icon icon="users" /> Cloud </router-link></li>
               <li><router-link tag="a" to="/servicios"> <font-awesome-icon icon="users" /> Servicios </router-link></li>
            </ul>
          </li>
        </ul>
      </aside>

        <aside class="menu" >
        <p class="menu-label">
          &nbsp;&nbsp;&nbsp; Operaciones
        </p>
        <ul class="menu-list">
          <li>
            <ul>
              <li><router-link tag="a" :to="'/reservar/'"> <font-awesome-icon icon="users" /> Reservar</router-link></li>
              <li><router-link tag="a" :to="'/service/1'"> <font-awesome-icon icon="users" /> Service</router-link></li>
              <li><router-link tag="a" to="/pickups-asignacion"> <font-awesome-icon icon="calendar-alt" /> Pickups Asignación</router-link></li>
              <li> <a :class="(validadorClick == 17) ? 'is-active' : '' " @click="changeCompon('app-pickups_reporte'),validadorClick = 17 "><font-awesome-icon icon="calendar-alt" /> Pickups Reporte </a> </li>
              <li> <a :class="(validadorClick == 18) ? 'is-active' : '' " @click="changeCompon('app-regresos'),validadorClick = 18 "><font-awesome-icon icon="calendar-alt" /> Regresos </a> </li>
              <li> <a :class="(validadorClick == 19) ? 'is-active' : '' " @click="changeCompon('app-regresos_reporte'),validadorClick = 19 "><font-awesome-icon icon="calendar-alt" /> Regresos Reporte </a> </li>
              <li> <a :class="(validadorClick == 21) ? 'is-active' : '' " @click="changeCompon('app-no_show'),validadorClick = 21 "><font-awesome-icon icon="calendar-alt" /> No Show </a> </li>
              <li> <a :class="(validadorClick == 22) ? 'is-active' : '' " @click="changeCompon('app-cancelados'),validadorClick = 22 "><font-awesome-icon icon="calendar-alt" /> Cancelados </a> </li>
              <li> <a :class="(validadorClick == 20) ? 'is-active' : '' " @click="changeCompon('app-gps'),validadorClick = 20 "><font-awesome-icon icon="calendar-alt" /> GPS </a> </li>
            </ul>
          </li>
        </ul>
      </aside>

      <aside class="menu">
        <p class="menu-label">
          &nbsp;&nbsp;&nbsp; Sesión
        </p>
        <ul class="menu-list">
          <li>
            <ul>
              <li>
                <a  @click="cerrarSesion"> <font-awesome-icon icon="sign-out-alt" />  Cerrar Sesión</a>
              </li>
              <li>
                <a @click="changeCompon('app-historial'),validadorClick = 11 "> 
                <font-awesome-icon icon="exchange-alt" />   Historial Movimientos </a>
              </li>

            </ul>
          </li>
        </ul>
      </aside>

    </div> -->
    

  </div>

  <div id="modalBusqueda" class="modal" align="center">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <span class="modal-card-title">
          <strong>Búsqueda en fecha {{this.buscaReservaFecha}}</strong>
        </span>
        <button class="delete" @click="cerrarModalBusqueda" aria-label="close"></button>
      </header>
      <section class="modal-card-body" align="left">
        
        <template v-for="reserva in reservacionesList" >
          <span v-text="reserva.cliente"> </span><br>
        </template>


      </section>
      <footer class="modal-card-foot">
        <button @click="cerrarModalBusqueda" class="button is-info">Cerrar</button>
      </footer>
    </div>
  </div>

  <footer class="footer">
    <div class="content has-text-centered">
      
        <strong>Exodus tickets</strong> by <a href="https://sistemy.mx">Sistemy</a>. 
        
        <router-link tag="a" to="/aviso_privacidad">Lee nuestro aviso de privacidad</router-link>
        <!-- <router-link tag="a" to="/">
          <a @click="changeCompon('app-aviso_privacidad'),validadorClick = 11 ">avisooo</a>
        </router-link> -->
        
        Escríbenos a exodus@sistemy.mx
      
      <br>
      <router-link tag="a" to="/terminos_condiciones">
        Términos y condiciones.
      </router-link>
      <br>
      <router-link tag="a" to="/servicios">
        Servicios.
      </router-link>
      <br>
      <router-link tag="a" to="/contacto">
        Contacto.
      </router-link>
    </div>
  </footer>

</div>
</template>

<script>

import axios from 'axios'
import Cors from 'cors'
import moment from 'moment'

import { EventBus } from './bus.js';
import qs from 'qs'

import Servicios from './exodus/servicios.vue'
import Services from './exodus/services.vue'
import Aviso_privacidad from './exodus/aviso_privacidad.vue'
import Terminos_condiciones from './exodus/terminos_condiciones.vue'
import Contacto from './exodus/contacto.vue'
import Reservar from './empleados/reservar.vue'
import Pickups from './empleados/pickups.vue'
import PickupsReporte from './empleados/pickups_reporte.vue'
import Regresos from './empleados/regresos.vue'
import RegresosReporte from './empleados/regresos_reporte.vue'
import NoShow from './empleados/no_show.vue'
import Cancelados from './empleados/cancelados.vue'
import Gps from './empleados/gps.vue'

import Cloud from './sistemy/cloud.vue'



export default {

  components: {
    'app-servicios': Servicios,
    'app-services': Services,
    'app-aviso_privacidad': Aviso_privacidad,
    'app-terminos_condiciones': Terminos_condiciones,
    'app-contacto': Contacto,
    'app-services': Services,
    'app-reservar': Reservar,
    'app-pickups' : Pickups,
    'app-pickups_reporte' : PickupsReporte,
    'app-regresos' : Regresos,
    'app-regresos_reporte' : RegresosReporte,
    'app-no_show' : NoShow,
    'app-cancelados' : Cancelados,
    'app-gps' : Gps,

    'app-cloud' : Cloud
  },
  data () {
    return {
      menuComponente: 'app-servicios',
      mail: '',
      pass: '',
      option: '0',
      alturaVentana: window.innerHeight - 100,
      anchoVentana: window.innerWidth - 20,
      validadorClick: 0,
      total: 0,
      buscaReservaFecha: moment().format('DD-MM-YYYY'),
      buscaReserva:'',
      reservacionesList:'',
      showMenuMobile:false,
      host: 'exodustickets.sistemy.mx',
      pathEnglish:this.$route.path,
      checkpath : this.$route.path.length

    }
  },
  computed: {

  },

  created () {
    
    var estancia = this;
    console.log("test jp",this.$route.path)
    console.log(this.$route.params,'params')
    if(this.$route.path=='/'){
      this.router.push('/servicios')
    }
    console.log(this.$cookies.get('RhSession'),'sesion info')


    EventBus.$on('cambioCompon',(datoInt, datoString) => {

      estancia.changeCompon(datoString);
      estancia.validadorClick = datoInt ;

    })

    document.addEventListener('DOMContentLoaded', function () {
      // Dropdowns
      var $dropdowns = getAll('.dropdown:not(.is-hoverable)')

      if ($dropdowns.length > 0) {
        $dropdowns.forEach(function ($el) {
          $el.addEventListener('click', function (event) {
            event.stopPropagation()
            $el.classList.toggle('is-active')
          })
        })

        document.addEventListener('click', function (event) {
          closeDropdowns()
        })
      }

      function closeDropdowns () {
        $dropdowns.forEach(function ($el) {
          $el.classList.remove('is-active')
        })
      }

      // Close dropdowns if ESC pressed
      document.addEventListener('keydown', function (event) {
        var e = event || window.event
        if (e.keyCode === 27) {
          closeDropdowns()
        }
      })

      // Functions

      function getAll (selector) {
        return Array.prototype.slice.call(document.querySelectorAll(selector), 0)
      }

    })
  },
  methods: {
    updatepath() {
      this.checkpath = this.$route.path.length;
      console.log(this.checkpath,'se actualiza checkpath')
    },
    
    menuMobile () {
      this.showMenuMobile=!this.showMenuMobile
    },
    buscarReservacion () {
        // axios.post('http://localhost:3000/justRead',{
        //   select: 'id, nombre',
        //   table: 'monedas',
        //   where: '',
        //   condition: ''
        // })
        var select = `*`;
        var tabla = "reservaciones";
        var where = " fecha = '"+this.buscaReservaFecha+"' and cliente like '%"+this.buscaReserva+"%' ";
        axios.get(`https://${this.host}/assignFunction.php?action=justRead&select=${select}&tabla=${tabla}&where=${where}`)
        .then((response)=>{
          if (response.status == 200 ) {
            this.reservacionesList = response.data;
            console.log(response,'response');
            $("#modalBusqueda").addClass("is-active");
          }else{
            console.log('error');
          }
        });
    },
    cerrarModalBusqueda:function(){
      $("#modalBusqueda").removeClass("is-active");
      this.reservacionesList=''
      this.buscaReserva=''
    },
    hoy () {
      return moment().format('DD-MM-YYYY')
    },
    cerrarSesion: function () {
      this.$cookies.remove('RhSession')
      location.reload()
    },
    current: function (selected) {
      this.option = selected
    },
    changeCompon: function (data) {
      // console.log(this.$route,'router?')
      // this.router.push('/')
      console.log('cambiamos el componente')
      console.log(data)
      this.menuComponente = data
    }
  }
}
</script>